import React from 'react';
import { createRoot } from 'react-dom/client';
import VisitLetterPreviewPanel from '../components/VisitLetters/VisitLetterPreviewPanel';
import { splitLetterContent } from './visitLetterDisplay';

/**
 * Mounts VisitLetterPreviewPanel off-screen and returns .generate-letter-preview-content HTML for PDF.
 */
export function renderLetterPreviewHtml({
  letterKind,
  header,
  body,
  footer,
  visitMeta,
  projectCode,
  siteId,
}) {
  return new Promise((resolve, reject) => {
    const container = document.createElement('div');
    container.setAttribute('data-visit-letter-pdf-root', '1');
    container.style.cssText = 'position:fixed;left:-10000px;top:0;width:800px;visibility:hidden;pointer-events:none;';
    document.body.appendChild(container);

    const root = createRoot(container);
    let settled = false;

    const cleanup = () => {
      try {
        root.unmount();
      } catch (_) { /* ignore */ }
      if (container.parentNode) {
        container.parentNode.removeChild(container);
      }
    };

    const finish = () => {
      if (settled) return;
      settled = true;
      const previewEl = container.querySelector('.generate-letter-preview-content');
      const html = previewEl?.outerHTML ?? '';
      cleanup();
      if (!html.trim()) {
        const parts = splitLetterContent(header, body, footer);
        if (!parts.headerText && !parts.bodyHtml && !parts.footerText && !parts.issuesHtml) {
          const e = new Error('Letter preview HTML is empty.');
          e.code = 'EMPTY_PREVIEW';
          reject(e);
          return;
        }
      }
      resolve(html);
    };

    const timeout = setTimeout(finish, 15000);

    root.render(
      <VisitLetterPreviewPanel
        letterKind={letterKind}
        header={header}
        body={body}
        footer={footer}
        visitMeta={visitMeta}
        projectCode={projectCode}
        siteId={siteId}
        onReady={() => {
          clearTimeout(timeout);
          finish();
        }}
      />
    );
  });
}
